import externalRedirect from '~/modules/ecommerceCore/utils/externalRedirect';

const openGoogleMap = (lat, lng) => {
  const url = `https://maps.google.com/?q= ${lat},${lng}`;
  externalRedirect(url, '_blank');
};
export default openGoogleMap;
